import React from "react";
import {Typography} from "@material-ui/core";
import {BenefitsItemType} from "./index";
import {maskCurrency} from "../../../utils/commonUtils";


type BenefitsCardProps = { benefits: BenefitsItemType[]; title: string; }


const BenefitsCard: React.FC<BenefitsCardProps> = ({benefits, title}) => {
    return (
            <>
                <Typography variant="h4" component="strong" className="mb15 floatLeft w100 colorWhite">
                    {title}
                </Typography>
                {
                    benefits.map((item, key) => (
                            <div key={key} className="mb20 floatLeft w100">
                                <Typography variant="body1" className="mb0 floatLeft w100 colorWhite">
                                    {
                                        item.label
                                    }
                                </Typography>
                                <Typography variant="h3" component="strong" className="mb0 floatLeft w100 colorWhite">
                                    {
                                        maskCurrency(item.value)
                                    }
                                </Typography>
                            </div>
                    ))
                }
            </>
    );
};


export default BenefitsCard;
